export default {
  SET_CURRENT_STAT(state, payload) {
    state.currentStat = payload
  },
}
